import Vue from 'vue';

import auth_base from './base/auth'
import crud_base from './base/crud'

import data_table from './global/page/data-table';
import form from './global/page/form';

import list from './global/page/list-card';
import add from './global/page/add-card';

import confirmationDialog from './global/page/confirmation-dialog';
import moduleSelector from './global/page/ModuleSelector';

import snackbarAlert from './global/page/snackbar-alert';



// import select_survey from './select-survey'
// import questionnaire from './questionnaire/index.vue'
// import questions from './questions'

// import range from './sections/range'
// import rating from './sections/rating'
// import multiple_select from './sections/multiple-select'
// import yes_no from './sections/yes-no'

// import button_icon from './button_icon'


Vue.component('b-auth', auth_base);
Vue.component('b-crud', crud_base);
Vue.component('g-data-table', data_table);
Vue.component('g-form', form);
Vue.component('g-list-card', list);
Vue.component('g-add-card', add);
Vue.component('g-confirmation-dialog', confirmationDialog);
Vue.component('g-module-selector', moduleSelector);
Vue.component('g-snackbar-alert', snackbarAlert);



// Vue.component('g-select-survey', select_survey);
// Vue.component('g-questionnaire', questionnaire);
// Vue.component('g-questions', questions);

// Vue.component('g-range', range);
// Vue.component('g-rating', rating);
// Vue.component('g-multiple-select', multiple_select);
// Vue.component('g-yes-no', yes_no);

// Vue.component('g-button_icon', button_icon);